<div *ngIf="hasFiltri"  class="card-body align-middle">
  <div class="row align-middle">
    <div class="col-lg-2 form-group">
      <label class="mb-0 text-dark">{{'container.targa' | translate}}</label>
      <input type="text" #inizio = "ngModel"  [(ngModel)]="Filtri.targa" (ngModelChange)="refreshTable(1)" name="inizio" class="form-control">
    </div>
    <div class="col-lg-2 form-group">
      <label class="mb-0 text-dark">{{'container.fattura' | translate}}</label>
      <input type="text" #fine = "ngModel"  [(ngModel)]="Filtri.fattura" (ngModelChange)="refreshTable(1)" name="fine" class="form-control">
    </div>
  </div>
</div>
<div class="d-md-flex align-items-center bg-white p-3">
    <span class="d-flex align-items-center p-2 ">
    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> {{'menu.vocicontainer' | translate}}:</h5>
    <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{collectionSize}}</span>
    </span>
</div>
<div class="table-responsive">
  <table class="table bg-white table-hover align-middle mb-0">
    <thead>
    <tr>
      <th>{{'lavorazioni.voce' | translate}}</th>
      <th scope="col">{{'lavorazioni.ordine' | translate}}</th>
      <th scope="col">{{'lavorazioni.quantita' | translate}}</th>
      <th scope="col">{{'lavorazioni.acquisto' | translate}}</th>
      <th scope="col">{{'container.editTitle' | translate}}</th>
      <th scope="col" *ngIf="permission.isPermitted('gestione-container')">{{'lavorazioni.azioni' | translate}}</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of List">
      <td >
        <span class="font-14">{{item.voce.includes(',') ? item.voce.substr(0,item.voce.indexOf(',')-1) : item.voce}}</span>
      </td>
      <td >
        <span class="font-14">{{item.ordine}}</span>
      </td>
      <td>
        <span *ngIf="!item.modifica" class="font-14">{{item.quantita}}</span>
        <span *ngIf="item.modifica">
          <input [(ngModel)]="item.quantita" min="0" [max]="item.disponibilita" type="number" class="form-control">
        </span>
      </td>
      <td>
        <span  class="font-14">{{item.acquisto}}</span>
      </td>
      <td>
        <span *ngIf="!item.modifica" class="font-14">{{item.containerObject.targa}}</span>
        <span *ngIf="item.modifica">
           <ng-multiselect-dropdown [settings]="dropdownSettings" [placeholder]="'Container'"  [data]="Container"
                                    [(ngModel)]="item.containerObjects" placement="top">
           </ng-multiselect-dropdown>
        </span>
      </td>
      <td class="align-middle">
        <a
          href="javascript:void(0)"
          [ngbTooltip] ="item.modifica ? ('inline.save'|translate) : ('inline.edit'|translate)"
          class="link font-16 text-info font-medium mr-2"
          (click)='Edit(item)'>
          <i class="fas" [ngClass]="{'fa-pencil-alt': !item.modifica, 'fa-check': item.modifica}"></i>
        </a>
<!--        <a-->
<!--          href="javascript:void(0)"-->
<!--          [ngbTooltip] ="item.modifica ? ('inline.cancel'|translate) : ('inline.delete'|translate)"-->
<!--          class="link font-16 text-danger font-medium mr-2"-->
<!--          (click)='DeleteStock(item)'>-->
<!--          <i class="fas" [ngClass]="{'fa-trash-alt': !item.modifica, 'fa-times': item.modifica}"></i>-->
<!--        </a>-->
      </td>
    </tr>
    </tbody>
    <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>
  </table>

</div>




